module.exports = __webpack_public_path__ + "static/media/150.6b208436.svg";